<template>
  <div
    :class="[wrapClass, {'is-open': status.isOpen}]"
    class="boss-mini-accordion"
  >
    <div
      :class="headClass"
      class="boss-mini-accordion-head"
      @click="toggle"
    >
      {{ title }}
    </div>
    <div class="boss-mini-accordion-body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    wrapClass: {
      type: String,
      default: ''
    },
    headClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      status: {
        isOpen: this.isOpen
      }
    }
  },
  mounted () {
    // 印刷画面close時に画面上の表示を切り替える
    window.addEventListener('transitionend', this.toggledAction)
  },
  beforeDestroy () {
    // eventListenerの削除
    window.removeEventListener('transitionend', this.toggledAction)
  },
  methods: {
    toggle () {
      this.status.isOpen = !this.status.isOpen
      this.$emit('toggle')
    },
    toggledAction () {
      this.$emit('toggled')
    }
  }
}
</script>
